import React, { useRef, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useTranslation } from 'react-i18next';

function HtmlEditorModal({ toggle, value, handleChange }) {
  const { t } = useTranslation('common');
  const editorRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleEditorChange = (_event, editor) => {
    const newValue = editor.getData();
    setLocalValue(newValue);
  };

  const handleClose = () => {
    if (localValue !== value) {
      try {
        handleChange(localValue);
      } catch (error) {
        console.error('Error updating HTML content:', error);
        // Still close the modal even if there's an error
      }
    }
    toggle();
  };

  return (
    <Modal enforceFocus={false} show size="lg" backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" className="custom-modal">
      <form>
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title id="contained-modal-title-vcenter">{t('RANGE_PLANS.PRODUCT_LIST.RENDER_HTML_COMPONENET.HTML_EDITOR.EDIT_TASK_NOTES')}</Modal.Title>
            <span onClick={handleClose} className="icon-close cursor-pointer" />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            <CKEditor
              editor={ClassicEditor}
              data={localValue}
              config={{
                height: 400,
                toolbar: [
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  'underline',
                  '|',
                  'link',
                  'bulletedList',
                  'numberedList',
                  '|',
                  'undo',
                  'redo',
                  'alignment',
                  '|',
                  'fontFamily',
                  'fontSize',
                  'fontColor',
                  '|',
                  'removeFormat',
                  'horizontalLine',
                  'fullScreen',
                ],
                typing: { spellChecker: false }, // Disable spellcheck
                removePlugins: ['MediaEmbed', 'EasyImage'], // Remove unused plugins
              }}
              onChange={handleEditorChange}
              onReady={(editor) => {
                editorRef.current = editor;
                editor.setData(localValue);
              }}
            />
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
}

export default HtmlEditorModal;
